import React, { useState } from 'react';
import { orderBy } from 'lodash';
import { downloadLeaderboardPng } from '../lib/exportLeaderboardPng';

function initials(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

function Crown() {
  return (
    <svg className="podium-crown" viewBox="0 0 40 28" aria-hidden="true">
      <path
        fill="#FFD54A"
        d="M4 22 L8 8 L16 16 L20 4 L24 16 L32 8 L36 22 Z"
      />
      <rect x="4" y="20" width="32" height="6" rx="2" fill="#F5C842" />
      <circle cx="8" cy="8" r="2.2" fill="#FFF3C4" />
      <circle cx="20" cy="4" r="2.4" fill="#FFF3C4" />
      <circle cx="32" cy="8" r="2.2" fill="#FFF3C4" />
    </svg>
  );
}

function Medal({ place }) {
  const labels = { 1: '1', 2: '2', 3: '3' };
  return (
    <span className={`final-medal medal-${place}`} aria-hidden="true">
      {labels[place]}
    </span>
  );
}

function Avatar({ name, size = 'md', crowned = false }) {
  return (
    <div className={`podium-avatar size-${size} ${crowned ? 'crowned' : ''}`}>
      {crowned ? <Crown /> : null}
      <span className="podium-avatar-ring">
        <span className="podium-avatar-inner">{initials(name)}</span>
      </span>
    </div>
  );
}

export default function Podium({ players, scores, roomID = null }) {
  const [saving, setSaving] = useState(false);

  const ranked = orderBy(
    players.map((p) => ({
      ...p,
      score: scores[p.id] !== undefined ? scores[p.id] : 0,
    })),
    ['score', 'name'],
    ['desc', 'asc']
  );

  const top = ranked.slice(0, 3);
  const podiumOrder = [
    top[1] ? { player: top[1], place: 2 } : null,
    top[0] ? { player: top[0], place: 1 } : null,
    top[2] ? { player: top[2], place: 3 } : null,
  ].filter(Boolean);

  const onDownload = async () => {
    if (saving || ranked.length === 0) return;
    setSaving(true);
    try {
      await downloadLeaderboardPng(ranked, { roomID });
    } catch (e) {
      // eslint-disable-next-line no-alert
      window.alert('Rasmni saqlab bo‘lmadi. Qayta urinib ko‘ring.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="results finale">
      <h2>Reyting</h2>

      {top.length > 0 ? (
        <div className="podium-stage" role="list">
          {podiumOrder.map(({ player, place }) => (
            <div
              key={player.id}
              className={`podium-col place-${place}`}
              role="listitem"
            >
              <Avatar
                name={player.name}
                size={place === 1 ? 'lg' : 'md'}
                crowned={place === 1}
              />
              <p className="podium-name">{player.name}</p>
              <p className="podium-pts">
                {player.score} <span>ball</span>
              </p>
              <div className="podium-block" aria-hidden="true">
                <span className="podium-block-num">{place}</span>
              </div>
            </div>
          ))}
        </div>
      ) : null}

      {ranked.length > 0 ? (
        <>
          <div className="final-sheet">
            <div className="final-sheet-handle" aria-hidden="true" />
            <ol className="final-standings">
              {ranked.map((p, i) => {
                const place = i + 1;
                return (
                  <li key={p.id}>
                    {place <= 3 ? (
                      <Medal place={place} />
                    ) : (
                      <span className="rank">{place}</span>
                    )}
                    <span className="final-avatar" aria-hidden="true">
                      {initials(p.name)}
                    </span>
                    <span className="lb-name">{p.name}</span>
                    <span className="lb-score">
                      {p.score}
                      <span className="lb-score-unit"> ball</span>
                    </span>
                  </li>
                );
              })}
            </ol>
          </div>

          <button
            type="button"
            className="btn-download-lb"
            onClick={onDownload}
            disabled={saving}
          >
            {saving ? 'Tayyorlanmoqda…' : 'Rasmni yuklab olish'}
          </button>
        </>
      ) : (
        <p className="hint center-hint">Natija yo‘q</p>
      )}
    </div>
  );
}
